<template>
    <section class="questions questions--reactive" id="questions">
        <div class="questions__container">
            <p id="title">Reactive News</p>
            <div class="questions__questions">
                <div>
                    <p id="question-action">Question</p>
                    <p id="question">{{Content.en_gb.reactive.questions[0].question}}</p>
                    <button id="yes-answer" @click="updateYesAnswer">Yes</button>
                    <button id="no-answer" @click="updateNoAnswer">No</button>
                    <button id="continue" @click="continueAnswer">Continue</button>
                    <span id="reset" @click="reset">Start Again</span>
                </div>
                <img src="../assets/images/reactive.png" alt="">
            </div>
        </div>
    </section>
</template>
<script>
import Content from "../data/content.js";

    let step = 0;
    let path = '';

    export default {

    name: "Question",
    methods: {

        async updateYesAnswer() {
            let question = document.getElementById('question');
            let questionAction = document.getElementById('question-action');
            let yes = document.getElementById('yes-answer');
            let no = document.getElementById('no-answer');

            if (path == '') {
                path = 'yes';
            }

            if (path == 'yes') {
                if (step > -1 && step < 2) {
                    question.innerHTML = Content.en_gb.reactive.yesPath[step].question;
                } else if (step == 2) {
                    question.innerHTML = Content.en_gb.reactive.releaseAction;
                    yes.style.display = 'none';
                    no.style.display = 'none';
                    questionAction.innerText = 'Action';
                }
            } else {
                if (step > 0 && step < 11) {
                    questionAction.innerText = 'Action';
                    question.innerHTML = Content.en_gb.reactive.emailAnswer;
                    yes.style.display = 'none';
                    no.style.display = 'none';
                } else if (step == 11) {
                    question.innerHTML = Content.en_gb.reactive.yesPath[1].question;
                } else {
                    question.innerHTML = Content.en_gb.reactive.yesPath[step].question;
                }
            }
            
            step++;
        },

        async updateNoAnswer() {
            if (path == '') {
                path = 'no';
            }

            let question = document.getElementById('question');
            let questionAction = document.getElementById('question-action');
            let yes = document.getElementById('yes-answer');
            let no = document.getElementById('no-answer');
            let continueAnswer = document.getElementById('continue');


            if (path == 'no') {
                if (step > 0 && step < 11) {
                    question.innerHTML = Content.en_gb.reactive.noPath[step].question;
                } else if (step == 0) {
                    question.innerHTML = Content.en_gb.reactive.noPath[step].question;
                } else if (step == 11) {
                    question.innerHTML = Content.en_gb.reactive.noPath[step].question;
                    continueAnswer.style.display = 'block';
                    questionAction.innerText = 'Action';
                    yes.style.display = 'none';
                    no.style.display = 'none';
                } else if (step == 12) {
                    question.innerHTML = Content.en_gb.reactive.noPath[11].question;
                    continueAnswer.style.display = 'block';
                    questionAction.innerText = 'Action';
                    yes.style.display = 'none';
                    no.style.display = 'none';
                } else {
                    questionAction.innerText = 'Action';
                    question.innerHTML = Content.en_gb.reactive.emailAnswer;
                    yes.style.display = 'none';
                    no.style.display = 'none';
                }
            } else {
                if (step == 1 || step == 2) {
                    question.innerHTML = Content.en_gb.reactive.noPath[11].question;
                    continueAnswer.style.display = 'block';
                    questionAction.innerText = 'Action';
                    yes.style.display = 'none';
                    no.style.display = 'none';

                }
            }
            step++;
        },

        async reset() {
            window.location.reload();
        },


        async continueAnswer() {
            let continueAnswer = document.getElementById('continue');
            let question = document.getElementById('question');
            continueAnswer.style.display = 'none';
            question.innerHTML = Content.en_gb.reactive.releaseAction;
        }
    },

        data: function () {
        return {
            Content,
        }
        }


};

</script>
<style lang="scss">

</style>